import React from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import CharactersList from "./characters/CharactersList";
import CharacterForm from "./characters/CharacterForm";
import CharacterDetail from "./characters/CharacterDetail";
import { CharacterRequest } from "../types/types";
import { CharacterService } from "../services/characterService";

const Characters: React.FC = () => {
  const navigate = useNavigate();

  const handleCharacterCreate = async (characterData: CharacterRequest) => {
    const newCharacter = await CharacterService.createCharacter(characterData);
    navigate(`/protected/characters/${newCharacter.id}`);
  };

  return (
    <Routes>
      <Route path="/" element={<CharactersList />} />
      <Route
        path="/create"
        element={
          <CharacterForm
            onSave={handleCharacterCreate}
            onCancel={() => navigate("/protected/characters")}
          />
        }
      />
      <Route path="/:id" element={<CharacterDetail />} />
    </Routes>
  );
};

export default Characters;
